(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kg-pdp-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  const tag = 'kindgut-halloween-announcement';
  if (customElements.get(tag)) return;
  const duration = 10 * 60 * 60 * 1000;
  const storageKey = 'kindgut:halloween:session-deadline:v1';
  let memoryDeadline = null;

  function getDeadline() {
    const now = Date.now();
    try {
      const stored = Number(sessionStorage.getItem(storageKey));
      if (Number.isFinite(stored) && stored > 0) {
        memoryDeadline = stored;
        return stored;
      }
      const deadline = memoryDeadline || now + duration;
      sessionStorage.setItem(storageKey, String(deadline));
      memoryDeadline = deadline;
      return deadline;
    } catch (_) {
      // Storage-denied browsers keep a working countdown for this document.
      memoryDeadline = memoryDeadline || now + duration;
      return memoryDeadline;
    }
  }

  class KindGutHalloweenAnnouncement extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.start());
    }

    start() {
      if (!this.isConnected || this.cleanup) return;
      const timer = this.querySelector('[data-kg-hwb-timer]');
      const expiry = this.querySelector('[data-kg-hwb-expiry]');
      const wrapper = this.closest('.kg-pdp-editor-section');
      const root = this.closest('[data-pc-bp]');
      if (!timer || !expiry || !wrapper || !root) return;
      const deadline = getDeadline();
      const header = document.querySelector('#header-group');
      const controller = new AbortController();
      let interval;
      const tick = () => {
        const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
        const remainder = String(seconds % 60).padStart(2, '0');
        timer.textContent = hours + ':' + minutes + ':' + remainder;
        expiry.hidden = false;
        if (seconds === 0) clearInterval(interval);
      };
      const measure = () => {
        const headerStyle = header ? getComputedStyle(header) : null;
        const headerSticks = headerStyle && (headerStyle.position === 'sticky' || headerStyle.position === 'fixed');
        const offset = headerSticks ? Math.ceil(header.getBoundingClientRect().height) : 0;
        const height = Math.ceil(wrapper.getBoundingClientRect().height);
        wrapper.style.setProperty('--kg-hwb-header-height', offset + 'px');
        root.style.setProperty('--kg-hwb-offset', offset + 'px');
        root.style.setProperty('--kg-hwb-height', height + 'px');
      };
      tick();
      if (deadline > Date.now()) interval = setInterval(tick, 1000);
      measure();
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
      observer?.observe(wrapper);
      if (header) observer?.observe(header);
      window.addEventListener('resize', measure, { signal: controller.signal });
      window.addEventListener('pageshow', tick, { signal: controller.signal });
      document.addEventListener('visibilitychange', tick, { signal: controller.signal });
      this.cleanup = () => {
        clearInterval(interval);
        observer?.disconnect();
        controller.abort();
        wrapper.style.removeProperty('--kg-hwb-header-height');
        root.style.removeProperty('--kg-hwb-offset');
        root.style.removeProperty('--kg-hwb-height');
        this.cleanup = null;
      };
    }

    disconnectedCallback() {
      this.cleanup?.();
    }
  }
  customElements.define(tag, KindGutHalloweenAnnouncement);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kg-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = '__kgMobileReviewLoops';
  const selector = '[data-kg-review-loop]';
  if (window[key]) {
    window[key].init(document);
    return;
  }

  const instances = new Map();
  const mobile = window.matchMedia('(max-width: 600px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function create(root) {
    const rail = root.querySelector('[data-kg-review-rail]');
    const groups = rail && Array.from(rail.children).filter((node) => node.matches('[data-kg-review-group]'));
    if (!rail || groups.length < 2) return null;
    const button = root.querySelector('[data-kg-review-pause]');
    root.dataset.kgLoopReady = '';
    if (button) button.hidden = false;
    const listeners = [];
    let destroyed = false;
    let frame = 0;
    let timer = 0;
    let previousTime = null;
    let segment = 0;
    let position = rail.scrollLeft;
    let expectedScroll = rail.scrollLeft;
    let explicitPause = false;
    let motionAllowed = false;
    let manualPause = false;
    let focusPause = false;
    let editorPause = false;
    let intersecting = true;
    let activePointer = null;
    let drag = null;

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push(() => target.removeEventListener(type, handler, options));
    }

    function optedOut() {
      return explicitPause || (reduced.matches && !motionAllowed);
    }

    function writeScroll(value) {
      rail.scrollLeft = value;
      expectedScroll = rail.scrollLeft;
    }

    function measure() {
      const first = groups[0].getBoundingClientRect();
      const second = groups[1].getBoundingClientRect();
      const gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
      segment = second.left - first.left || groups[0].offsetWidth + gap;
    }

    function visible() {
      if (!root.isConnected || !root.getClientRects().length || !rail.clientWidth) return false;
      const style = window.getComputedStyle(root);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
    }

    function canRun() {
      return !destroyed && mobile.matches && !document.hidden && intersecting && visible() &&
        !optedOut() && !manualPause && !focusPause && !editorPause && activePointer === null &&
        segment > 0 && rail.scrollWidth - rail.clientWidth >= segment - 1;
    }

    function updateButton() {
      if (!button) return;
      const paused = optedOut();
      const label = paused ? root.dataset.playLabel : root.dataset.pauseLabel;
      button.setAttribute('aria-pressed', String(paused));
      if (label) {
        button.textContent = label;
        button.setAttribute('aria-label', label);
      }
    }

    function stop() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      previousTime = null;
      root.dataset.kgLoopState = 'paused';
    }

    function tick(time) {
      frame = 0;
      if (!canRun()) {
        stop();
        return;
      }
      if (previousTime !== null) {
        const elapsed = Math.min(Math.max(time - previousTime, 0), 50);
        position = (position + elapsed * 0.024) % segment;
        writeScroll(position);
      }
      previousTime = time;
      frame = window.requestAnimationFrame(tick);
    }

    function sync() {
      if (destroyed) return;
      updateButton();
      if (!canRun()) {
        stop();
        return;
      }
      if (frame) return;
      position = ((Math.max(rail.scrollLeft, 0) % segment) + segment) % segment;
      if (Math.abs(position - rail.scrollLeft) > 0.01) writeScroll(position);
      root.dataset.kgLoopState = 'running';
      previousTime = null;
      frame = window.requestAnimationFrame(tick);
    }

    function releaseManual() {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        timer = 0;
        manualPause = false;
        sync();
      }, 1600);
    }

    function manual() {
      manualPause = true;
      stop();
      releaseManual();
    }

    function refresh() {
      if (destroyed) return;
      measure();
      if (frame && segment > 0) {
        position = ((position % segment) + segment) % segment;
      }
      sync();
    }

    function pointerEnd(event) {
      if (activePointer === null || (event.pointerId !== undefined && event.pointerId !== activePointer)) return;
      activePointer = null;
      drag = null;
      releaseManual();
    }

    listen(rail, 'pointerdown', (event) => {
      if (!mobile.matches || activePointer !== null || (event.pointerType === 'mouse' && event.button !== 0)) return;
      activePointer = event.pointerId;
      focusPause = false;
      if (event.pointerType === 'mouse') drag = { x: event.clientX, scroll: rail.scrollLeft };
      manual();
    });
    listen(document, 'pointermove', (event) => {
      if (!drag || event.pointerId !== activePointer) return;
      if (Math.abs(event.clientX - drag.x) > 4) {
        event.preventDefault();
        writeScroll(drag.scroll + drag.x - event.clientX);
        manual();
      }
    }, { passive: false });
    listen(document, 'pointerup', pointerEnd);
    listen(document, 'pointercancel', pointerEnd);
    listen(window, 'blur', pointerEnd);
    listen(rail, 'dragstart', (event) => {
      if (mobile.matches) event.preventDefault();
    });
    listen(rail, 'wheel', () => {
      if (mobile.matches) manual();
    }, { passive: true });
    listen(rail, 'scroll', () => {
      if (!mobile.matches || Math.abs(rail.scrollLeft - expectedScroll) < 1.5) return;
      expectedScroll = rail.scrollLeft;
      manual();
    }, { passive: true });
    listen(rail, 'focusin', () => {
      if (activePointer === null) {
        focusPause = true;
        sync();
      }
    });
    listen(rail, 'focusout', (event) => {
      if (!rail.contains(event.relatedTarget)) {
        focusPause = false;
        manual();
      }
    });
    listen(rail, 'keydown', () => {
      focusPause = true;
      manual();
    });
    if (button) listen(button, 'click', () => {
      const resume = optedOut();
      explicitPause = !resume;
      if (resume) {
        motionAllowed = true;
        manualPause = false;
        window.clearTimeout(timer);
        timer = 0;
      }
      sync();
    });

    const resize = window.ResizeObserver ? new ResizeObserver(refresh) : null;
    if (resize) [root, rail, groups[0]].forEach((node) => resize.observe(node));
    const intersection = window.IntersectionObserver ? new IntersectionObserver((entries) => {
      intersecting = entries[0].isIntersecting;
      sync();
    }) : null;
    if (intersection) intersection.observe(root);
    const mutation = window.MutationObserver ? new MutationObserver(refresh) : null;
    if (mutation) {
      let ancestor = root;
      while (ancestor && ancestor !== document.documentElement) {
        mutation.observe(ancestor, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
        ancestor = ancestor.parentElement;
      }
    }
    refresh();

    return {
      refresh,
      sync,
      motionChanged() {
        motionAllowed = false;
        sync();
      },
      select(target) {
        if (!mobile.matches || !groups[0].contains(target)) return;
        editorPause = true;
        stop();
        const item = target.getBoundingClientRect();
        const viewport = rail.getBoundingClientRect();
        if (item.left < viewport.left) writeScroll(rail.scrollLeft + item.left - viewport.left);
        else if (item.right > viewport.right) writeScroll(rail.scrollLeft + item.right - viewport.right);
      },
      deselect() {
        if (!editorPause) return;
        editorPause = false;
        manual();
      },
      destroy() {
        destroyed = true;
        stop();
        window.clearTimeout(timer);
        listeners.forEach((remove) => remove());
        if (resize) resize.disconnect();
        if (intersection) intersection.disconnect();
        if (mutation) mutation.disconnect();
        delete root.dataset.kgLoopReady;
        if (button) button.hidden = true;
      }
    };
  }

  function init(scope) {
    instances.forEach((instance, root) => {
      if (!root.isConnected) {
        instance.destroy();
        instances.delete(root);
      }
    });
    const roots = Array.from(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) roots.unshift(scope);
    roots.forEach((root) => {
      if (instances.has(root)) instances.get(root).refresh();
      else {
        const instance = create(root);
        if (instance) instances.set(root, instance);
      }
    });
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((instance, root) => {
      if (event.target === root || event.target.contains(root)) {
        instance.destroy();
        instances.delete(root);
      }
    });
  });
  document.addEventListener('shopify:section:reorder', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    instances.forEach((instance) => instance.select(event.target));
  });
  document.addEventListener('shopify:block:deselect', () => {
    instances.forEach((instance) => instance.deselect());
  });
  document.addEventListener('visibilitychange', () => instances.forEach((instance) => instance.sync()));
  window.addEventListener('resize', () => instances.forEach((instance) => instance.refresh()), { passive: true });
  mobile.addEventListener('change', () => instances.forEach((instance) => instance.refresh()));
  reduced.addEventListener('change', () => instances.forEach((instance) => instance.motionChanged()));
  window[key] = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
